import { useState } from 'react';

const faqs = [
  {
    q: '吃瓜表情包真的免费吗？',
    a: '是的，本站所有吃瓜群众表情图、吃瓜动图均免费供围观场景使用，无需注册即可浏览和保存。我们会持续补充新的围观素材，让你每次吃瓜都有新配图。',
  },
  {
    q: '怎么把表情包保存到手机或电脑？',
    a: '在「表情大全」或「动图专区」里点击任意卡片即可放大预览，之后即可通过系统方式保存到相册或本地。找到喜欢的表情，随点随存，非常方便。',
  },
  {
    q: '表情包多久更新一次？',
    a: '我们每天都会上新。围绕最新围观热点、热门梗和常见表情场景进行补充，确保「震惊」「蹲后续」「看戏」等需求随时都能找到对味的那一张。',
  },
  {
    q: '可以用表情包做头像或发朋友圈吗？',
    a: '本站表情以表达围观、吃瓜、调侃的情绪场景为主，适合聊天配图、评论区互动和日常娱乐使用。在个人娱乐范围内使用都没有问题。',
  },
  {
    q: '为什么我搜索关键词找不到表情？',
    a: '建议先试更简短的情绪词，比如「震惊」「无语」「偷笑」。若仍没有结果，可以换近义词，或清空关键词浏览全部表情，很多灵感就藏在分类里。',
  },
  {
    q: '我想贡献自己做的吃瓜表情，怎么联系？',
    a: '如果你有原创吃瓜表情想分享给更多围观群众，欢迎通过页面底部「关于我们」区的联系邮箱联系我们，把素材发给我们即可。',
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-question-line" /> 你关心的都在这里
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-foreground-700">
            关于吃瓜表情包的免费使用、保存下载、更新节奏，一次讲清楚。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  active ? 'border-secondary-300 bg-secondary-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  onClick={() => setOpen(active ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                  <i
                    className={`text-xl text-foreground-500 transition-transform duration-200 ${
                      active ? 'rotate-180 text-secondary-600' : ''
                    } ri-arrow-down-s-line`}
                  />
                </button>
                {active && (
                  <div className="border-t border-secondary-200/70 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}